import { bl_fi_einvoice_email_ocr_doc_line_RowClass } from '../../dbschema';
import { bl_fi_einvoice_email_ocr_doc_hdr_RowClass } from '../../dbschema/bl_fi_einvoice_email_ocr_doc_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class EInvoiceEmailOcrDocHdrContainerModel extends BaseContainerModel {
    bl_fi_einvoice_email_ocr_doc_hdr: bl_fi_einvoice_email_ocr_doc_hdr_RowClass = new bl_fi_einvoice_email_ocr_doc_hdr_RowClass();
    bl_fi_einvoice_email_ocr_doc_lines: bl_fi_einvoice_email_ocr_doc_line_RowClass[] = [];
}
